module.exports = __webpack_public_path__ + "img/login-information-vknows.150fed23.webp";